import React, {
  Component,
  Fragment
} from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  Route,
  Switch,
  Redirect
} from 'react-router-dom';

import {
  HomeCarousel
} from './HomeComponent';

import {
  Results,
  Album
} from '../';

import {
  Search,
  Suggestions
} from '../../components';

import {
  // BulmaHero,
  BulmaSection
} from '../../components/HelperComponents/HelperComponents';

import {
  HTitle
} from '../../components/HelperComponents/StyledComponents';

import {
  fetchNewAlbumsIfNeeded
} from '../../actions/HomeActions';
import { Favorites } from '../Favorites/Favorites';

const H3 = HTitle('h3');

const HeaderMain = (props) => (
  <section className="container">
    <section className="columns is-centered">
      <section className="column is-11">
        <Search searchBackgroundColor={props.searchBackgroundColor} searchPlaceholderAlign={props.searchPlaceholderAlign} />
      </section>
    </section>
  </section>
);

class HomeComponent extends Component {
  static propTypes = {
    dispatch: PropTypes.any,
    newSongs: PropTypes.object,
    items: PropTypes.array,
    match: PropTypes.object,
    params: PropTypes.object
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchNewAlbumsIfNeeded());
  }

  render() {
    const covers = this.props.items || [];
    const activatePadding = this.props.location.pathname === '/' ? true : false;
    const searchBackgroundColor = this.props.location.pathname === '/' ?  'linear-gradient(to right, #252525 1%, #1d1d1d)' : 'transparent';
    const searchPlaceholderAlign = this.props.location.pathname === '/' ? 'center' : 'left';
    const hideSuggestionsOnFavorite = this.props.location.pathname === '/favorites' ? 'none' : '';

    return (
      <Fragment>
        <HeaderMain activatePadding={activatePadding} searchBackgroundColor={searchBackgroundColor} searchPlaceholderAlign={searchPlaceholderAlign} />

        <BulmaSection columnsClassName="is-centered is-multiline" sectionPadding="0 1.5rem 3rem 1.5rem">
          <Switch>
            <Route path={`${this.props.match.path}favorites`} component={Favorites} exact />
            <Route path={`${this.props.match.path}results/:searchQuery`} component={Results} exact />
            <Route path={`${this.props.match.path}album/:albumId`} component={Album} exact />
            <Redirect to="/" />
          </Switch>

          <Suggestions allCovers={covers} suggestionDisplay={hideSuggestionsOnFavorite}>
            <H3 theme={{
              fontSize: '18px',
              marginTop: '0.75rem'
            }}>Featured Albums</H3>
          </Suggestions>
        </BulmaSection>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { newAlbums } = state;
  const {
    isFetching,
    lastUpdated,
    items
  } = newAlbums || {
    isFetching: true,
    items: []
  };

  return {
    items,
    isFetching,
    lastUpdated
  };
}

const Home = connect(mapStateToProps)(HomeComponent);

export { Home };



// WEBPACK FOOTER //
// ./src/routes/Home/Home.js